import { ApiService } from "./api.service";
import type {
  TCapacityRebalanceRequest,
  TCapacityRebalanceResponse,
} from "@/types/capacity-rebalance";

export class CapacityRebalanceService extends ApiService {
  async propose(
    slug: string,
    body: TCapacityRebalanceRequest,
  ): Promise<TCapacityRebalanceResponse> {
    return this.post(`/api/workspaces/${slug}/capacity-rebalance/`, body);
  }
}
